module.exports = __webpack_public_path__ + "img/1-4.27fe3973.png";